import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * The app sends no email. A member of staff who forgot their password asks at
 * a centre, and the super admin hands them a link to set a new one.
 */
export default function ForgotPasswordPage() {
  return (
    <>
      <Helmet>
        <title>Recuperar palavra-passe | DIGGER</title>
      </Helmet>
      <div className="min-h-screen flex items-center justify-center bg-background py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <h1 className="text-center text-3xl font-bold text-foreground">
              DIGGER
            </h1>
            <h2 className="mt-6 text-center text-2xl font-semibold text-foreground">
              Memória de peixe? 🐟
            </h2>
          </div>

          <div className="bg-card border border-border p-4 rounded-md text-sm space-y-2">
            <p className="text-foreground">
              Dirige-te ao <strong>CICF</strong> ou ao <strong>CCDV</strong> e pede uma ligação de
              recuperação.
            </p>
            <p className="text-muted-foreground">
              Com ela defines uma nova palavra-passe. Funciona uma vez e durante 24 horas.
            </p>
          </div>

          <p className="text-center text-sm text-muted-foreground">
            {'Afinal lembraste-te? '}
            <Link to="/login" className="text-primary hover:text-primary/80 font-medium">
              Iniciar sessão
            </Link>
          </p>
        </div>
      </div>
    </>
  );
}
